import React from 'react'
import { motion } from 'framer-motion'
import './VirtualTour.css'

const VIRTUAL_TOUR_URL =
  'https://www.google.com/maps/embed?pb=!4v1780386273632!6m8!1m7!1sCAoSHENJQUJJaENXT0dSblJSVTh1Zm1URUIxbTlBZWY.!2m2!1d50.24074929211523!2d16.40466933679905!3f70.65432707817561!4f-14.159747890808461!5f0.7820865974627469'

function VirtualTour({ compact = false }) {
  return (
    <motion.div
      id="virtualni-prohlidka"
      className={`virtual-tour ${compact ? 'virtual-tour-compact' : ''}`}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, delay: 0.1 }}
      viewport={{ once: true }}
    >
      <h3>Virtuální prohlídka</h3>
      <div className="virtual-tour-frame">
        <iframe
          title="360° virtuální prohlídka penzionu"
          src={VIRTUAL_TOUR_URL}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </motion.div>
  )
}

export default VirtualTour
